import React from 'react';
import api from 'api';
import { DropdownSelector, TextInput } from 'hyperdb-utils';
import ModalFormCustomer from './ModalFormCustomer';

class CustomersSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    if (!this.props.customerId) this.state.showCustomerSearch = true;
    this.handleChange = this.handleChange.bind(this);
    this.handleCustomerCreated = this.handleCustomerCreated.bind(this);
    this._initialized = false;
  }
  componentDidMount() {
    this.fetchCustomers();
  }
  componentWillReceiveProps(nextProps) {
    if (!this._initialized && nextProps.customers) {
      this._initialized = true;
      this.props.api.customer.setData({ loading: false });
    }
  }
  componentWillUnmount() {
    this.props.api.customer.setData({ customers: null, entities: null });
  }
  render() {
    return (
      <div>
        {
          this.state.showCustomerSearch
          ? this.renderSearch()
          : this.renderSelector()
        }
        <ModalFormCustomer show={ this.props.showModalCustomer } onClose={ this.toggleModalCreateCustomer.bind(this, false) } onCustomerSaved={ this.handleCustomerCreated } />
      </div>
    );
  }

  renderSelector() {
    return (
      <DropdownSelector
        label={
          <span>
            Customer { this.props.required ? ' *' : '' }
            &nbsp;
            {
              !this.props.noCreate
                ? <button type="button" className="btn btn-xs btn-primary" onClick={ this.toggleModalCreateCustomer.bind(this, true) }>New</button>
                : null
            }
            &nbsp;
            <button type="button" className="btn btn-xs btn-primary" onClick={ this.toggleCustomerSearch.bind(this, true) }>Search...</button>
          </span>
        }
        placeholder={ this.props.loading ? 'LOADING ...' : '--- Select customer ---' }
        name="customer"
        value={ this.props.customerId || '' }
        options={ this.customersOptions(this.props.customers || [], this.props.entities || []) }
        onChange={ this.handleChange }
      />
    );
  }

  renderSearch() {
    return (
      <div className="form-group">
        <label htmlFor="customerSearch">
          Customer { this.props.required ? ' *' : '' }
          &nbsp;
          {
            !this.props.noCreate
              ? <button type="button" className="btn btn-xs btn-primary" onClick={ this.toggleModalCreateCustomer.bind(this, true) }>New</button>
              : null
          }
        </label>
        <div className= { 'input-group input-group-sm search-filter ' }>
          <input
            type="text"
            name="customerSearch"
            placeholder="customer..."
            className="form-control"
            onChange={ this.handleFilterChange.bind(this) }
           />
          <div className="input-group-btn">
            <button className="btn btn-default" onClick={ this.handleCustomerSearch.bind(this) } type="button">
              <i className="fas fa-search"></i>
            </button>
          </div>
        </div>
      </div>
    );
  }

  fetchCustomers(filter) {
    this.props.api.customer.setData({ loading: true });
    const queryOptions = [
      ['id', 'name', 'language', ['entity', ['first_name', 'last_name', 'primary_email', 'title'] ]],
      { order: { name: 'asc' } }
    ];
    if (filter) {
      queryOptions[1].where = {$any: [
        {'name': {match: filter}},
        {'entity.primary_email': {match: filter}},
      ]};
    }
    else if (this.props.customerId) {
      if (!this.props.forEmail) {
        queryOptions[1].where = {id: this.props.customerId};
      } else {
        const email = this.getCustomerEmailFromRecipient(this.props.customerId);
        queryOptions[1].where = {'entity.primary_email': email};
      }
    } else {
      return this.props.api.customer.setData({ customers: [], entities: [] });
    }
    return this.props.api.customer.getObjects({
      queryOptions,
    });
  }
  customersOptions(customers, entities) {
    if (!customers) return [];
    const option = this.props.option
      ? this.props.option
      : (c) => ({ name: c.name, value: c.id });
    return customers.map(customer => {
      if (!customer.entity.value[1]) return { ...customer, entity: {} };
      const entity = entities.find(i => i.id === customer.entity.value[1]) || {};
      return option({ ...customer, entity });
    });
  }
  getCustomerEmailFromRecipient(recipient) {
    if (recipient.match('<')) {
      const [displayName, email] = recipient.split(' <');
      return email.split('>')[0];
    } else {
      return recipient;
    }
  }

  toggleModalCreateCustomer(bool) {
    this.props.api.customer.setData({ showModalCustomer: bool });
  }
  toggleCustomerSearch(bool) {
    this.setState({...this.state, showCustomerSearch: bool});
  }
  handleChange(field) {
    this.props.onChange(field.value);
  }
  handleCustomerCreated(customer) {
    this._initialized = false;
    const customers = this.props.customers.concat(customer);
    customers.sort((a, b) => (a.name || '').trim().localeCompare((b.name || '').trim()));
    const entities = this.props.entities.concat(customer.entity_data);
    this.props.api.customer.setData({ showModalCustomer: false, customers, entities });
    this.toggleCustomerSearch(false);
    if (this.props.onCustomerCreated) this.props.onCustomerCreated(customer);
  }
  handleFilterChange(ev) {
    this.setState({...this.state, customerFilter: ev.target.value});
  }
  handleCustomerSearch() {
    const filter = this.state.customerFilter;
    this.toggleCustomerSearch(false);
    if (filter) this.fetchCustomers(filter);
  }
}

export default api.connect(CustomersSelector, 'customer');



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/common/CustomersSelector.jsx